// Copyright component with Easter eggs for OHIT identification
import { useSettings } from '../contexts/SettingsContext';

interface CopyrightProps {
  className?: string;
  showEasterEgg?: boolean;
}

export default function Copyright({ className = '', showEasterEgg = false }: CopyrightProps) {
  const { settings } = useSettings();
  const currentYear = new Date().getFullYear();

  // Easter egg: OHIT identification in comments only (no console logs for performance)

  return (
    <div className={`text-center text-sm text-gray-500 ${className}`}>
      <p>© {currentYear} Northeast Georgia Health System. All rights reserved.</p>
      {/* Easter egg: Hidden OHIT identifier */}
      <div className='hidden' data-ohit='optimum-healthcare-it-transfer-system'>
        {/* OHIT: Optimum Healthcare IT Transfer System - Built with ❤️ for healthcare */}
      </div>
    </div>
  );
}
